import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Table, TableHead, TableBody, TableRow, TableCell,
  Button, CircularProgress, Typography, Box, Grid
} from '@mui/material';

const PedidoDetalleModal = ({ open, onClose, idPedido }) => {
  const [productos, setProductos] = useState([]);
  const [pedido, setPedido] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !idPedido) return;

    setLoading(true);
    fetch('https://bibliotecadlago.com/php/Backend/pedido_detalle.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ IdPedido: idPedido })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setPedido(data.pedido);
          setProductos(data.productos);
        } else {
          setPedido(null);
          setProductos([]);
        }
      })
      .catch(() => {
        setPedido(null);
        setProductos([]);
      })
      .finally(() => setLoading(false));
  }, [open, idPedido]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          flexDirection: "column"
        }}
      >
        <strong>
          Detalle del Pedido #{idPedido}<br />
        </strong>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {pedido ? (
              <>
                <Box mb={3} display="flex" justifyContent="flex-start">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} sx={{ marginRight: 8 }}>
                      <Typography><strong>Fecha:</strong> {pedido.Fecha}</Typography>
                      <Typography><strong>Cliente:</strong> {pedido.Nombre}</Typography>
                      <Typography><strong>Asesor:</strong> {pedido.Asesor}</Typography>
                      <Typography><strong>Ultimo cambio de estatus:</strong> {pedido.FechaCambio}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography><strong>Facturación:</strong> {pedido.Facturacion}</Typography>
                      <Typography><strong>Estatus:</strong> {pedido.Estatus}</Typography>
                      <Typography><strong>Realizado por:</strong> {pedido.NombreCambio}</Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Grid item xs={12}>
                  <Typography><strong>Comentario:</strong> {pedido.Comentario}</Typography>
                </Grid>
              </>



            ) : (
              <Typography color="error">No se pudo cargar la información del pedido.</Typography>
            )}

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">MSPN</TableCell>
                  <TableCell align="center">Descripción</TableCell>
                  <TableCell align="center">Cantidad</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productos.map((item) => (
                  <TableRow key={item.MSPN}>
                    <TableCell align="center">{item.MSPN}</TableCell>
                    <TableCell align="center">{item.descripcion}</TableCell>
                    <TableCell align="center">{item.Cantidad}</TableCell>
                  </TableRow>
                ))}
                {pedido ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      <strong>Total de Cantidad</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>{pedido.Total}</strong>
                    </TableCell>
                  </TableRow>
                ) : (
                  <Typography color="error">No se pudo cargar la información del pedido.</Typography>
                )}
                {productos.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">No hay productos en este pedido.</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" size="small" onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PedidoDetalleModal;
